export default __webpack_public_path__ + "static/media/visa.47b6590c.svg";